import { Injectable } from '@angular/core';
import { BaseSelectionService } from './base-selection';
import { FilteredSalesOrder } from './sales-order';

@Injectable({ providedIn: 'root' })
export class SalesOrderSelectionService extends BaseSelectionService<FilteredSalesOrder> {
}
